<template>
    <div class="container-hts margin-top-20">
        <div class="header-name-excercise">
            <h3><strong>{{ dataExcercise.name }}</strong></h3>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="text-center">
                    <h4>Nội dung đề</h4>
                </div>
                <div>
                    <div class="wrap-list-question" v-for="(item, index) of dataTeacher.dataUserWork" :key="index">
                        <div class="excercise-question margin-top-10" :class="{ 'is-choose': itemSelected == item }">
                            <!-- <div>Câu hỏi: {{ item.questionNumber }}</div>
                            <div class="answer">
                                <div class="title-answer">Đáp án:</div>
                                <div class="content-answer">
                                    {{ item.answer }}
                                </div>
                            </div> -->
                            <PreviewQuestion :ref="`PreviewQuestion_${item.questionItem.questionId}`"
                                :id="`question_${0}`" :dataSource="item.questionItem" :location="0" :disabled="true"
                                :questions="listQuestion" :isDontShowResultSaved="false" />
                            <!-- <div class="feedback-teacher">
                                <div class="title-feedback-teacher">Nhận xét giáo viên:</div>
                                <div v-html="item.feedback" class="content-answer">
                                </div>
                            </div> -->
                        </div>

                    </div>

                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <h4>Thông tin đề</h4>
                </div>
                <div class="wrap-top">
                    <div class="row">
                        <div class="name-member col-md-6">
                            <b-form-select @change="handleChangeUserId" v-model="dataTeacher.currentUserIdSelected"
                                :options="listOptionUser">
                            </b-form-select>
                        </div>
                        <div class="replay-member col-md-6">
                            <a @click="sendPointToMember" href="javascript:;"
                                class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add">
                                Trả điểm các bài đã chấm
                            </a>
                        </div>
                    </div>
                    <div class="row margin-top-10">
                        <div class="col-md-3">
                            Tổng điểm
                        </div>
                        <div class="col-md-3">
                            <div class="total-point">
                                {{ formatNumber(dataTeacher.totalPoint) }}
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="title-feedback col-md-12">
                            Lời phê
                        </div>
                        <div class="wrap-content col-md-12">
                            <!-- <textarea v-model="dataTeacher.feedback" class="secondary-color-txt content-feedback" rows="5"
                                placeholder="Ghi lời phê giáo viên tại đây..."></textarea> -->
                            <EditorCKNew class="margin-top-10" @onEditorChange="onEditorChangeFeedback"
                                :contentEditor="dataUserExcercise ? dataUserExcercise.feedback : ''" :position="'-1'" />
                        </div>
                    </div>
                </div>
                <div v-if="dataTeacher.currentUserIdSelected > 0" class="wrap-list-number-question">
                    <div class="row col-md-12">
                        <div class="col-md-2" v-for="(item, index) of this.dataTeacher.dataUserWork" :key="index">
                            <div @click="handleClickQuestion(item)" class="item-number"
                                :class="{ 'is-choose': item == itemSelected, 'is-check':Number.isFinite(item.pointTecherFill)  }">
                                {{ index + 1 }}
                            </div>
                        </div>

                    </div>
                </div>
                <!-- <div v-if="dataTeacher.currentUserIdSelected>0 && itemSelected" class="wrap-answer-member">
                    <div class="title-feedback">
                        Đáp án
                    </div>
                    <div class="wrap-content">
                        <div v-if="itemSelected.answerUserFill" readonly v-html="itemSelected.answerUserFill" class="fit-height secondary-color-txt content-feedback"></div>
                        <div v-else readonly class="fit-height secondary-color-txt content-feedback">
                            Học sinh chưa trả lời câu hỏi này.
                        </div>
                    </div>
                </div> -->
                <div v-if="dataTeacher.currentUserIdSelected > 0 && itemSelected" class="result-question margin-top-10">
                    <div class="display-flex justity-content-space-beetween">
                        <b-form-checkbox v-model="itemSelected.isMaxPoint" @change="handleMaxPoint" class="mb-3">
                            Tối đa
                        </b-form-checkbox>
                        <div class="display-flex">
                            <input :disabled="itemSelected.isMaxPoint" type="number" @input="handleChangeInputPoint"
                                v-model="itemSelected.pointTecherFill" autocomplete="off"
                                class="input-point-teacher" /><span class="max-point">/{{
                                    formatNumber(itemSelected.maxPoint) }} điểm</span>
                        </div>

                    </div>

                </div>
                <div v-if="dataTeacher.currentUserIdSelected > 0 && itemSelected" class="wrap-feedback-question">
                    <div class="title-feedback">
                        Nhận xét
                    </div>
                    <div class="wrap-content">
                        <!-- <textarea v-model="itemSelected.feedback" class="secondary-color-txt content-feedback" rows="5"
                            placeholder="Nhập xét của giáo viên tại đây..."></textarea> -->
                        <EditorCKNew :contentEditor="itemSelected.feedback" class="margin-top-10"
                            @onEditorChange="onEditorChangeAnswerFeedback" :position="itemSelected.id" />
                    </div>
                </div>
                <div v-if="dataTeacher.currentUserIdSelected > 0" class="text-center margin-bottom-20">
                    <button type="button" @click="handleSaveExcercise"
                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1 display-inline-block"
                        :disabled="isDisabledButtonSave">
                        Lưu bài vừa chấm
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'

import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import EditorCKNew from '@/components/EditorCKNew.vue'
import { getDetailExcerciseNeedGrading, getListAnswerMember, teacherSaveGrade, sendExcerciserToMember } from './../../../_api/userExcerciseClassSchool'
export default {
    components: {
        EditorCKNew,
        PreviewQuestion
    },
    data() {
        return {
            TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL,
            isDisabledButtonSave: false,
            isLoading: false,
            options: [
                { item: true, name: 'Đúng' },
                { item: false, name: 'Sai' },

            ],

            dataExcercise: {},
            listOptionUser: [],
            apiUrl: APP_CONFIG.appUrl + 'lessons/',
            dataUserAnswerCurrent: [],
            dataTeacher: {
                currentUserIdSelected: 0,
                lessonClassSchoolId: 0,
                classSchoolId: 0,
                totalPoint: 0,
                feedback: '',
                isTeacherFillAll: false,
                dataUserWork: [],
            },
            itemSelected: null,
            dataUserExcercise: null,
            listQuestion: []
        }
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    mounted() {
        this.dataTeacher.lessonClassSchoolId = this.$route.query.id
        this.dataTeacher.classSchoolId = this.$route.query.classSchoolId
        this.getData()
    },
    methods: {
        clearData(){
            this.dataExcercise= {}
            this.listOptionUser= []
            this.dataUserAnswerCurrent=[]
            this.dataTeacher.currentUserIdSelected=0
            this.dataTeacher.totalPoint=0
            this.dataTeacher.feedback=''
            this.dataTeacher.isTeacherFillAll=false
            this.dataTeacher.dataUserWork=[]

            this.itemSelected= null
            this.dataUserExcercise= null
            this.listQuestion= []
        },
        onEditorChangeFeedback(e) {
            this.dataTeacher.feedback = e.html
        },
        handleMaxPoint(e) {
            if (e) {
                this.itemSelected.pointTecherFill = this.itemSelected.maxPoint
            }
            else {
                this.itemSelected.pointTecherFill = ''
            }
            this.handleOnChangePoint()
        },
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(2);
        },
        onEditorChangeAnswerFeedback(e) {
            this.itemSelected.feedback = e.html
        },
        sendPointToMember() {
            let self = this
            sendExcerciserToMember({ id: this.dataTeacher.lessonClassSchoolId, classSchoolId:this.dataTeacher.classSchoolId }).then((res) => {
                if(res.data == 1){
                    self.$toast.success('Điểm đã được gửi đến học sinh thành công')
                }
                else{
                    self.$toast.error('Chưa có học sinh nào đã chấm để trả điểm')
                }
            })
        },
        handleSaveExcercise() {
            this.isDisabledButtonSave = true
            let self = this
            // format point trước
            let isTeacherFillAll = true
            for (let i = 0; i < this.dataTeacher.dataUserWork.length; i++) {
                const item = this.dataTeacher.dataUserWork[i];
                if (!item.pointTecherFill) {
                    isTeacherFillAll = false
                    break
                }
            }
            this.dataTeacher.isTeacherFillAll = isTeacherFillAll

            teacherSaveGrade(this.dataTeacher).then((res) => {
                if (res && res.data && !res.errors) {
                    // const routeData = this.$router.resolve({ path: '/soan-tai-lieu'});
                    //  window.open(routeData.href, '_blank');
                    self.$toast.success('Lưu bài chấm thành công')
                    this.isDisabledButtonSave = false
                    this.getData()
                }
            })
        },
        handleOnChangePoint() {
            this.dataTeacher.totalPoint = 0
            for (let i = 0; i < this.dataTeacher.dataUserWork.length; i++) {
                const item = this.dataTeacher.dataUserWork[i];
                if (item.isTrue) {
                    this.dataTeacher.totalPoint += parseFloat(item.pointTecherFill ? item.pointTecherFill : 0)
                }
            }
        },
        handleClickQuestion(item) {
            this.itemSelected = item
        },
        handleChangeInputPoint() {
            //tính tổng điểm cho giáo viên
            if (parseFloat(this.itemSelected.pointTecherFill) > parseFloat(this.itemSelected.maxPoint)) {
                this.itemSelected.pointTecherFill = this.itemSelected.maxPoint
            }


            this.dataTeacher.totalPoint = 0
            for (let i = 0; i < this.dataTeacher.dataUserWork.length; i++) {
                const item = this.dataTeacher.dataUserWork[i];

                if (item.isTrue) {
                    this.dataTeacher.totalPoint += parseFloat(item.pointTecherFill ? item.pointTecherFill : 0)
                }
            }
        },
        handleChangeUserId() {
            let self = this
            let params = {
                userId: this.dataTeacher.currentUserIdSelected,
                lessonClassSchoolId: this.dataTeacher.lessonClassSchoolId,
                classSchoolId: this.dataTeacher.classSchoolId,
                typeUploadExcercise: this.dataExcercise.typeUploadExcercise
            }
            getListAnswerMember(params).then((res) => {
                if (res && res.data && !res.errors) {
                    this.dataUserAnswerCurrent = res.data.listUserExcerciseAnswer
                    this.isDisabledButtonSave = false
                    // update đáp án vào user
                    this.dataUserExcercise = res.data.userExcercise
                    if (this.dataUserExcercise) {
                        this.dataTeacher.totalPoint = this.dataUserExcercise.point
                        if(this.dataUserExcercise.status ==5){
                            this.isDisabledButtonSave = true
                        }
                    }
                    else{
                        this.isDisabledButtonSave = true
                        //this.dataTeacher.currentUserIdSelected = 0
                        this.dataUserExcercise=null
                        this.dataTeacher.totalPoint =''
                        for (let i = 0; i < this.dataTeacher.dataUserWork.length; i++) {
                            let item = this.dataTeacher.dataUserWork[i];
                            item.answerUserFill = ''
                            item.userExcerciseAnswerQuestionId =''
                            item.pointTecherFill = ''
                            item.feedback = ''
                            item.isMaxPoint = false
                        }
                    }
                    
                    for (let i = 0; i < this.dataTeacher.dataUserWork.length; i++) {
                        let item = this.dataTeacher.dataUserWork[i];
                        for (let j = 0; j < this.dataUserAnswerCurrent.length; j++) {
                            const element = this.dataUserAnswerCurrent[j];
                            if (item.excerciseQuestionId == element.excerciseQuestionId) {
                                item.answerUserFill = element.answerUserFill
                                item.userExcerciseAnswerQuestionId = element.id
                                item.pointTecherFill = element.pointTeacherFill
                                item.feedback = element.feedback
                                item.isMaxPoint = element.pointTeacherFill == item.maxPoint ? true : false
                                
                                break
                            }
                        }
                    }
                    

                    // gán câu trả lời của học sinh vào list question
                    for (let q = 0; q < this.dataTeacher.dataUserWork.length; q++) {
                        let question = this.dataTeacher.dataUserWork[q].questionItem;
                        question.isWorked = true
                        for (let a = 0; a < question.answers.length; a++) {
                            let answer = question.answers[a];
                            const userAnswer = this.getUserExcerciseAnswer(res.data.listUserAnswerClassSchool, answer.answerId, question.questionId)
                            if (userAnswer) {
                                answer.validateVal = userAnswer.validateValString ? userAnswer.validateValString.split(',') : []
                                answer.validate = userAnswer.validateString ? userAnswer.validateString.split(',') : []
                                answer.answerContent = userAnswer.answerContent;
                                answer.isError = userAnswer.isError;
                            }
                            else {
                                answer.isError = false;
                            }
                        }
                        if (question.type == self.TYPE_MATH_COL) {
                            self.$refs[`PreviewQuestion_${question.questionId}`][0].reLoadData()
                        }
                        
                    }
                    // setTimeout(() => {
                    //     console.log('runnn')
                    //     for (let q = 0; q < self.dataTeacher.dataUserWork.length; q++) {
                    //         let question = self.dataTeacher.dataUserWork[q].questionItem;
                    //         if (question.type == self.TYPE_MATH_COL) {
                    //             console.log(question)
                               
                    //         }
                    //     }
                    // }, 1000);


                }
            })
        },
        getUserExcerciseAnswer(listUserAnswerClassSchool, answerId, questionId) {
            for (let i = 0; i < listUserAnswerClassSchool.length; i++) {
                const element = listUserAnswerClassSchool[i];
                if (element.answerId == answerId && element.questionId == questionId) {
                    return element
                }
            }
            return null
        },
        getData() {
            this.clearData()
            let params = {
                id: this.dataTeacher.lessonClassSchoolId,
                classSchoolId: this.dataTeacher.classSchoolId
            }
            this.listOptionUser = []
            getDetailExcerciseNeedGrading(params).then((res) => {
                if (res && res.data && !res.errors) {
                    this.dataExcercise = res.data.lessonClassSchool

                    for (let i = 0; i < res.data.listUser.length; i++) {
                        const item = res.data.listUser[i];
                        this.listOptionUser.push({ value: item.userId, text: item.fullName })

                    }
                    this.listQuestion = []
                    // format lại data câu hỏi
                    for (let i = 0; i < res.data.lessonClassSchool.listExcerciseQuestionClassSchool.length; i++) {
                        const item = res.data.lessonClassSchool.listExcerciseQuestionClassSchool[i];
                        this.dataTeacher.dataUserWork.push({
                            questionNumber: i + 1,
                            content: item.content,
                            excerciseQuestionId: item.id,
                            userExcerciseAnswerQuestionId: 0,
                            maxPoint: item.point,
                            pointTecherFill: '',
                            isMaxPoint: false,
                            isTrue: true,
                            answer: '',
                            answerUserFill: '',
                            feedback: '',
                            questionItem: item.practiceQuestion
                        })
                        this.listQuestion.push(item.practiceQuestion)
                    }
                    if (this.listOptionUser && this.listOptionUser.length > 0) {
                        this.dataTeacher.currentUserIdSelected = this.listOptionUser[0].value
                        this.handleChangeUserId()
                    }
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.fit-height {
    min-height: 1rem;
    max-height: 10rem;
    overflow: auto;
}

.is-check {
    background: #73a973 !important;
    color: white !important;
}

.is-choose {
    border: 2px solid blue !important;
}

.margin-bottom-20 {
    margin-bottom: 20px;
}

.ember-pdf {
    width: 100%;
    height: 40rem;
}

.display-inline-block {
    display: inline-block;
}

.content-feedback {
    border-radius: 15px;
    border: 1px solid #c7d0d7;
    padding: 10px;
}

.input-point-teacher {
    border: none;
    width: 100px;
    background: #b7ddf8;
    border-radius: 15px !important;
    margin-right: 10px;
    padding-left: 10px !important;
}

.total-point {
    background: #c2cdd5;
    text-align: center;
    border-radius: 15px;
    height: 30px;
    line-height: 30px;
}

.max-point {
    display: inline-block;
    margin: auto;
    width: 120px;
}

.wrap-list-number-question {
    .item-number {
        width: 100%;
        height: 30px;
        line-height: 30px;
        border: 1px solid #2032b5;
        text-align: center;
        border-radius: 15px;
        margin: 10px;
        background: #b7ddf8;
        color: #2132b5;
        cursor: pointer;
    }
}

.wrap-top {
    padding: 5px;
    border: 1px solid gainsboro;
    border-radius: 15px;
}

.content-feedback {
    width: 100%;
}

.list-answer {
    .answer-item {
        border: 1px solid #3e58c1;
        padding: 10px;
        border-radius: 15px;
        background: #e1eefe;
    }
}

.excercise-question {
    border: 1px solid #3e58c1;
    padding: 10px;
    border-radius: 15px;
    overflow: auto;
    .title-answer {
        color: #314cbd;
    }

    .feedback-teacher {
        .title-feedback-teacher {
            color: #ff4c56;
        }
    }
}

.margin-top-10 {
    margin-top: 10px;
}

.margin-top-20 {
    margin-top: 20px;
}

.justity-content-space-beetween {
    justify-content: space-between;
}

.justity-content-space-around {
    justify-content: space-around
}
</style>